import {entity} from "../rpc/api";
import ClientBookmarkList = entity.ClientBookmarkList;
import moment from "moment"

class ClientBookmarkConvertResponse {

    public static from(from: entity.ClientBookmark): ClientBookmarkConvertResponse {

        // Backend => FrontEnd における型変換
        const createdAtDate: Date = ClientBookmarkConvertResponse.convertToDate(from.createdAt);

        return new ClientBookmarkConvertResponse(
            from.clientID,
            from.customerID,
            createdAtDate,
        )
    }

    // Backend => FrontEnd における型変換　日付があればDate変換　なければ今日のDateを入れる
    private static convertToDate = (dateString: string): Date => {
        return (dateString) ? moment(dateString, "YYYY-MM-DD HH:II:SS").toDate() : moment().toDate()
    };

    constructor(public readonly clientID: string,
                public readonly customerID: string,
                public readonly createdAt: Date,) {

    }

}

class ClientBookmarkConvertResponseList {

    public static from(from: ClientBookmarkList): ClientBookmarkConvertResponseList {
        const items: ClientBookmarkConvertResponse[] = [];

        from.items.map((item, index) => {
            return items.push(ClientBookmarkConvertResponse.from(item as entity.ClientBookmark))
        });

        return new ClientBookmarkConvertResponseList(
            items,
        )
    };

    constructor(
        public readonly items: ClientBookmarkConvertResponse[],
    ) {
    };

}

export {
    ClientBookmarkConvertResponse,
    ClientBookmarkConvertResponseList,
}


// WEBPACK FOOTER //
// ./src/infra/api/service/client_bookmark_api_convert.ts